import { Suspense } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyBoardsHomeSidebarPlacement = ({
  workspaceId,
}: {
  workspaceId?: string;
}) => {
  const BoardsHomeSidebarPlacement = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "boards-home-sidebar-placement" */ './BoardsHomeSidebarPlacement'
      ),
    { namedImport: 'BoardsHomeSidebarPlacement' },
  );
  return (
    <Suspense>
      <BoardsHomeSidebarPlacement workspaceId={workspaceId} />
    </Suspense>
  );
};
